import { useState, useEffect } from 'react';
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import OTPInput from 'react-otp-input';
import apiService from '../service/apiService';
import Swal from 'sweetalert2';
import Loader from '../common/Loader';

const Home = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    const [show, setShow] = useState(false);
    const [otp, setOtp] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [checked, setChecked] = useState(false);
    const [errors, setErrors] = useState({});
    const [requestId, setRequestId] = useState('');
    const [otpError, setOtpError] = useState('');
    const [isLinkExpired, setIsLinkExpired] = useState(false);
    const [kycCompleted, setKycCompleted] = useState(false);

    const handleClose = () => {
        setShow(false);
        setOtp('');
        setOtpError('');
    }

    useEffect(() => {
        if (!kycCompleted) {
            checkTokenExpiry();
        }
    }, [])

    const checkTokenExpiry = async () => {
        try {
            const res = await apiService.verifyTokenExpiry(token);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setIsLinkExpired(true);
            }
            const message =
                error.response?.data?.message || 'Something went wrong. Please try again.';

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
            });
        }
    }

    const validateForm = () => {
        const newErrors = {};

        if (!name.trim()) {
            newErrors.name = 'Name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(name)) {
            newErrors.name = 'Only alphabets allowed';
        }

        if (!number.trim()) {
            newErrors.number = 'Aadhaar number is required';
        } else if (!/^\d{12}$/.test(number)) {
            newErrors.number = 'Aadhaar number must be 12 digits';
        }

        if (!checked) {
            newErrors.checkbox = ' ';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const data = { aadharNumber: number, aadharName: name, consent: 'Y' };

            try {
                setShowLoader(true);
                const res = await apiService.sendKycVerifyData(data);
                const response = res.data.data.response;

                if (response.success) {
                    setRequestId(response.request_id);
                    setShowLoader(false);
                    setShow(true);
                }
            } catch (error) {
                setShowLoader(false);
                const message =
                    error.response?.data?.message || 'Something went wrong. Please try again.';

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: message,
                });
            }
        }
    };


    const validateOtp = async () => {  
        if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
            setOtpError('Enter a valid 6-digit OTP');
        } else {
            try {
                const data = { requestId: requestId, token: token, otp: otp };
                setShowLoader(true);
                const res = await apiService.validateOtp(data);
                const response = res.data.data.response;
                if (response.success) {
                    setShowLoader(false);
                    Swal.fire({
                        icon: 'success',
                        title: 'KYC Completed!',
                    }).then(() => {
                        setKycCompleted(true)
                        setName('')
                        setNumber('')
                    });
                    setShow(false);
                }
            } catch (error) {
                setOtp('');
                setShowLoader(false);
                const message =
                    error.response?.data?.message || 'Something went wrong. Please try again.';

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: message,
                });
            }
        }
    };

    return (
        <>
            {showLoader && <Loader />}
            <section className="adhar-sct d-flex justify-content-center align-items-center">
                <Container>
                    <Row className="justify-content-between align-items-center">
                        <Col md={5} className='adhar-background'>
                            <img src={require('../assest/logo-main.svg').default} alt="Example" className='mb-3' />
                            <h1 className='my-3'><span className="grn">Validator KYC</span><br /> Build Trust with every Product</h1>
                            <div className="adr-box">
                                <h3>Complete your KYC to become a certified validator. Help ensure product authenticity and boost seller credibility across the platform.</h3>
                                <Form onSubmit={handleFormSubmit} className='mt-4'>
                                    <Form.Group className="mb-4">
                                        <Form.Label>Aadhaar Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={name}
                                            placeholder='Enter...'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setName(value);

                                                if (errors.name && value.trim() !== '') {
                                                    setErrors((prev) => ({ ...prev, name: '' }));
                                                }
                                            }}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Aadhaar Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder='Enter...'
                                            value={number}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value) && value.length <= 12) {
                                                    setNumber(value);

                                                    if (errors.number && value.length === 12) {
                                                        setErrors((prev) => ({ ...prev, number: '' }));
                                                    }
                                                }
                                            }}
                                            isInvalid={!!errors.number}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.number}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="consentCheckbox"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.target.checked)}
                                            isInvalid={!!errors.checkbox}
                                            label="I hereby declare that the information provided is accurate and consent to its use for verification purposes."
                                        />
                                        {errors.checkbox && <div className="text-danger">{errors.checkbox}</div>}
                                    </Form.Group>

                                    <Form.Group className="mt-5">
                                        <Button type="submit" className="primary-btn" disabled={isLinkExpired || kycCompleted}>
                                            Submit
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </div>
                        </Col>
                        <Col md={6} className='right-img'>
                        <img src={require('../assest/right-img.png')} alt="Example" className='' />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* OTP Modal */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className='border-0'>
                </Modal.Header>
                <Modal.Body>
                    <div className='verify-cmt'>
                        <h2>Verify your OTP</h2>
                        <p>Enter the OTP sent to your registered mobile number to verify your identity.</p>
                        <OTPInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span></span>}
                            renderInput={(props) => <input {...props} />}
                        />
                        {otpError && <p className="text-danger mt-2">{otpError}</p>}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <Button className="primary-btn" onClick={validateOtp}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Home;
